import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "d-flex pa-3 gc-6 gr-3 bg-secondary rounded",
      class: { "flex-column": _setup.isMobile },
      attrs: { "data-qa": "member_card" },
    },
    [
      _c(
        "div",
        { staticClass: "d-flex gc-6 align-center" },
        [
          _c(VImg, {
            staticClass: "flex-grow-0 rounded-circle",
            attrs: {
              "data-qa": "member_card_img",
              src:
                _vm.member.photo?.url ||
                "/static/_v1/pd/pictures/stubs/person-photo.png",
              "lazy-src": "/static/_v1/pd/pictures/stubs/person-photo.png",
              alt: _setup.t("Фото представителя", _setup.options),
              width: _setup.isMobile ? 80 : 150,
              height: _setup.isMobile ? 80 : 150,
            },
          }),
          _vm._v(" "),
          _setup.isMobile
            ? _c("div", { staticClass: "d-flex flex-column" }, [
                _c(
                  "div",
                  {
                    staticClass: "text-body-1 text--text",
                    attrs: { "data-qa": "member_card_fio" },
                  },
                  [
                    _vm._v("\n        " + _vm._s(_vm.member.last_name) + " "),
                    _c("br"),
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.member.first_name) +
                        " " +
                        _vm._s(_vm.member.second_name) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _setup.context.feature_flags.update_ethical_commission_page &&
                _vm.member.ethical_commission_member_grade
                  ? _c(
                      "div",
                      {
                        staticClass: "text-body-2 text--text",
                        attrs: { "data-qa": "member_card_role" },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _setup.t(
                                _vm.member.ethical_commission_member_grade,
                                _setup.options
                              )
                            ) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _setup.isMobile && _vm.member.occupations.length
        ? _c(VDivider, { staticClass: "mb-3" })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex flex-column ga-3 w-100" },
        [
          !_setup.isMobile
            ? _c("div", { staticClass: "d-flex flex-column" }, [
                _c(
                  "div",
                  {
                    staticClass: "text-body-1 text--text",
                    attrs: { "data-qa": "member_card_fio" },
                  },
                  [
                    _vm._v("\n        " + _vm._s(_vm.member.last_name) + " "),
                    _c("br"),
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.member.first_name) +
                        " " +
                        _vm._s(_vm.member.second_name) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _setup.context.feature_flags.update_ethical_commission_page &&
                _setup.memberGradeText
                  ? _c(
                      "div",
                      {
                        staticClass: "text-body-2 text--text",
                        attrs: { "data-qa": "member_card_role" },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _setup.t(_setup.memberGradeText, _setup.options)
                            ) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.member.occupations.length > 0
            ? [
                !_setup.isMobile
                  ? _c(VDivider, { staticClass: "my-3" })
                  : _vm._e(),
                _vm._v(" "),
                _vm.member.occupations.length > 1
                  ? _c(
                      "ul",
                      { staticClass: "text-body-2 text--text ml-3" },
                      _vm._l(_vm.member.occupations, function (occupation) {
                        return _c(
                          "li",
                          { key: occupation, staticClass: "ml-3" },
                          [
                            _vm._v(
                              "\n          " + _vm._s(occupation) + "\n        "
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _c("div", { staticClass: "text-body-2 text--text" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.member.occupations[0]) +
                          "\n      "
                      ),
                    ]),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }